export default __webpack_public_path__ + "static/media/Alien_Bottom.9cb83b27.svg";